import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

/**
 * Public (unauthenticated) KOL questionnaire endpoints. The emailed link
 * carries an opaque token that the backend gateway decodes into the company +
 * contact, so no company/speaker ids are passed from the client.
 */
@Injectable()
export class KolQuestionnaireService {
  private baseUrl = `${environment.apiBaseUrl}/kol_questionnaire`;

  constructor(
    private http: HttpClient,
  ) { }

  get(token: string): Observable<any> {
    const params = new HttpParams().set('token', token);
    return this.http.get<any>(this.baseUrl, { params });
  }

  /** Save progress (Next): persists answers; backend marks status 'draft' if unset. */
  save(token: string, esifFormId: any, data: any): Observable<any> {
    return this.http.put<any>(this.baseUrl, { token, esif_form_id: esifFormId, data, submit: false });
  }

  /** Finalize (Submit): persists answers and sets status to 'submitted'. */
  submit(token: string, esifFormId: any, data: any): Observable<any> {
    return this.http.put<any>(this.baseUrl, { token, esif_form_id: esifFormId, data, submit: true });
  }
}
